module.exports = __webpack_public_path__ + "img/senior.855e4694.jpg";